window.addEventListener("load", function () {
    const videoContainers = document.querySelectorAll('[data-video-container]');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const container = entry.target;
                const video = container.querySelector('video');
                const iframe = container.querySelector('iframe');
                const playButton = container.querySelector('[data-play-video]');

                // Set video poster
                if (video && video.hasAttribute('data-poster')) {
                    video.poster = video.getAttribute('data-poster');
                }

                // If play button exists
                if (playButton) {
                    playButton.addEventListener('click', () => {
                        // Play native video
                        if (video) {
                            video.play();
                            playButton.setAttribute('data-playing', 'true');

                            if (!video.loop) {
                                video.addEventListener('ended', () => {
                                    playButton.setAttribute('data-playing', 'false');
                                }, { once: true });
                            }
                        }

                        // Play YouTube or Vimeo iframe
                        if (iframe) {
                            const src = iframe.src;

                            // YouTube API
                            if (src.includes('youtube')) {
                                iframe.contentWindow.postMessage(JSON.stringify({
                                    event: "command",
                                    func: "playVideo",
                                    args: []
                                }), "*");
                            }

                            // Vimeo API
                            if (src.includes('vimeo')) {
                                iframe.contentWindow.postMessage({
                                    method: 'play'
                                }, '*');
                            }

                            playButton.setAttribute('data-playing', 'true');
                            // Optional: you would need an API or timeupdate event via postMessage to detect end
                        }
                    });
                }

                observer.unobserve(container);
            }
        });
    });

    videoContainers.forEach(container => {
        observer.observe(container);
    });
});
